import { useConfig } from '@borealis/huck/client';
import type { AppCfg, Cfg, LookupCfg } from '../../types/config.js';

// useConfig is an instance of "icefog", which means it is _not_ a React hook. Due to its naming, it will be considered a hook by linters-
export const getHuckConfig = useConfig<Cfg>;

/**
 * Get config for App.tsx routing - returns union type that can be narrowed by isLookupRoute
 */
export const getAppConfig = useConfig<AppCfg>;

/**
 * Get config specifically for lookup routes - only use when you know isLookupRoute is true
 */
export const getLookupConfig = useConfig<LookupCfg>;
